import React from 'react';
import tpl from '../templates/policy';
import BaseNewCardView from './../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            tab: 'insurer-info',
            tabShortIntermediaryInsuranceInfo: 'abank-short',
            tabFullIntermediaryInsuranceInfo: 'abank-full',
            detailedInfoWidget: (ssrData && ssrData.detailedInfoWidget) || [],
            detailedInfoWidget_loading: !(ssrData && ssrData.detailedInfoWidget)
        };
    }

    toggleShortIntermediaryInsuranceInfoTab = tab => {
        this.setState({tabShortIntermediaryInsuranceInfo: tab});
    };

    toggleFullIntermediaryInsuranceInfoTab = tab => {
        this.setState({tabFullIntermediaryInsuranceInfo: tab});
    };

    componentDidMount() {
        super.componentDidMount();
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/services/policy_oscpv',
            widgetKey: 'detailedInfoWidget'
        });
    }

    static displayName = 'Services.Policy';
}
